/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import { scroller } from "react-scroll";
import { useMyContext } from "../../MyContext";
import { useTranslation } from "react-i18next";
import HeroInfo from "./HeroInfo";
import Modal from "../../components/Modal";
import { CallWaiterButton, CallBillButton } from "../../components/CallButtons";
import Dev from "../../components/Dev";
import PromoBanner from "../../components/PromoBanner";

const Overlay = styled("div")(({ theme }) => ({
  position: "absolute",
  zIndex: 1,
  top: 0,
  left: 0,
  width: "100%",
  height: "75vh",
  background: theme.palette.secondary.beige,
}));

const HeroSection = styled("section")(({ theme }) => ({
  width: "100%",
  height: "75vh",
  background: `url("/img/hero-bg1.avif") top center`,
  backgroundSize: "cover",
  position: "relative",
  padding: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
}));

const TitleContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  textAlign: "center",
  zIndex: 99,
}));

const HeroTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 450,
  lineHeight: "2.9rem",
  color: theme.palette.text.dark,
  fontFamily: theme.typography.fontFamily,
  fontSize: "2.8rem",
  zIndex: 2,
}));

const HighlightedText = styled("p")(({ theme }) => ({
  fontWeight: 400,
  lineHeight: "0.9rem",
  fontFamily: theme.typography.h5.fontFamily,
  fontSize: theme.typography.h5.fontSize,
  textTransform: "uppercase",
  color: theme.palette.primary.green,
  textAlign: "center",
  zIndex: 22,
}));

const InfoContainer = styled(TitleContainer)({});

const CallButtonWrapper = styled(Stack)(({ theme }) => ({
  marginTop: 5,
  zIndex: 12,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export default function HeroSectionComponent({ scrollToMenu, devel }) {
  const {
    isSmallScreen,
    showTableHeader,
    zonti,
    rest,
    loadingModal,
    modalVisible,
    modalContent,
    isWaiterButtonActive,
    isButtonBillActive,
    handleCallWaiter,
    handleCallBill,
    hideModal,
    run,
    showScan,
    showInside,
    messageInside,
  } = useMyContext();
  const { t } = useTranslation();
  const [isSticky, setIsSticky] = useState(true);
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!zonti) {
      const timer = setTimeout(() => {
        scroller.scrollTo("menu", {
          duration: 800,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -55,
        });
      }, 4000);

      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(() => {
        scroller.scrollTo("menu", {
          duration: 800,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -475,
        });
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [scrollToMenu, zonti]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      const viewportHeight = window.innerHeight * 0.75;
      if (scrollY > viewportHeight) {
        setIsSticky(false);
      } else {
        setIsSticky(true);
      }
    };
    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const renderHeader = () => {
    // if (showLoading) {
    //   return <LoadingScreen rest={rest} />;
    // }

    if (!showTableHeader) {
      return (
        <InfoContainer>
          {showScan && (
            <ScanInfo t={t} isSmallScreen={isSmallScreen} rest={rest} />
          )}
          {showInside && (
            <InsideInfo
              isSmallScreen={isSmallScreen}
              messageInside={messageInside}
              rest={rest}
            />
          )}
        </InfoContainer>
      );
    }

    return (
      <>
        <HeroInfo zonti={zonti} name={rest.name} />
        <CallButtonWrapper
          sx={{
            mt: isSmallScreen ? 2 : 0,
            position: isSticky ? "sticky" : "fixed",
            bottom: isSticky ? "0px" : "-70px",
          }}
        >
          <CallWaiterButton
            showCallWaiterButton={true}
            isSticky={isSticky}
            isWaiterButtonActive={isWaiterButtonActive}
            handleCallWaiter={handleCallWaiter}
          />
          <CallBillButton
            showCallWaiterButton={true}
            isSticky={isSticky}
            isButtonBillActive={isButtonBillActive}
            handleCallBill={handleCallBill}
          />
        </CallButtonWrapper>
      </>
    );
  };

  return (
    <HeroSection id="hero">
      <Overlay />

      {!devel && (
        <TitleContainer
        // sx={{ mt: isSmallScreen && rest.slogans.length > 0 ? -5 : -4 }}
        >
          <HeroTitle className="puff-in-center ">
            <img
              width={isSmallScreen ? 350 : 500}
              height="auto"
              src="/logos/4.png"
              alt="logo1"
            ></img>{" "}
          </HeroTitle>
        </TitleContainer>
      )}

      <HighlightedText className="text-focus-in">
        Don't ask why!
      </HighlightedText>

      {!devel && <InfoContainer>{renderHeader()}</InfoContainer>}

      {/* <PromoBanner placement="hero" /> */}

      {devel && <Dev rest={rest} />}
      {modalVisible && (
        <Modal
          loading={loadingModal}
          content={modalContent}
          onClose={hideModal}
          run={run}
        />
      )}
    </HeroSection>
  );
}

const ScanInfo = ({ t, isSmallScreen, rest }) => {
  return (
    <TitleContainer>
      <Typography
        align="center"
        color="primary.red"
        sx={{
          fontSize: isSmallScreen ? "1.4rem" : "2.5rem",
          fontWeight: 900,
          lineHeight: isSmallScreen ? "1.4rem" : "2.5rem",
          zIndex: 111,
        }}
      >
        {t("hero.want")}
      </Typography>
      <Typography
        color="text.dark"
        align="center"
        sx={{
          fontSize: isSmallScreen ? "1.1rem" : "2.2rem",
          lineHeight: isSmallScreen ? "1.2rem" : "2.3rem",
          zIndex: 111,
        }}
      >
        {t("hero.scan")}
      </Typography>
    </TitleContainer>
  );
};

const InsideInfo = ({ isSmallScreen, messageInside, rest }) => {
  return (
    <TitleContainer>
      <Typography
        color="text.dark"
        align="center"
        sx={{
          fontSize: isSmallScreen ? "1.3rem" : "1.6rem",
          lineHeight: isSmallScreen ? "1.3rem" : "1.6rem",
          zIndex: 111,
        }}
      >
        {messageInside}
      </Typography>
    </TitleContainer>
  );
};

const Slogan = ({ isSmallScreen, slogan, rest }) => {
  return (
    <TitleContainer
      sx={
        {
          // mb: isSmallScreen && rest.slogans.length > 0 ? 3 : 2,
          // mt: isSmallScreen && rest.slogans.length > 0 ? -4 : -10,
        }
      }
    >
      <Typography
        color="text.dark"
        align="center"
        sx={{
          fontSize: isSmallScreen ? "1.3rem" : "1.6rem",
          lineHeight: isSmallScreen ? "1.3rem" : "1.6rem",
          zIndex: 111,
        }}
      >
        {slogan}
      </Typography>
    </TitleContainer>
  );
};
